/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1PCInfos, updateTKT1PCInfo, createTKT1PCInfo, deleteTKT1PCInfo } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Toast,
  ToastContainer
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import Select from 'react-select';

class TKT1PCInfo extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'location_id',
    sortOrder: 1,
    search: '',
    search_exact: false,
    status: '',
    use_type: ''
  }

  initShowColumns = {
    SN: true,
    location_id: true,
    operating_system: true,
    version: false,
    iso_file_name: false,
    c_drive_capacity: false,
    install_date: true,
    price: true,
    ref_device_pack_location_id: true,
    use_type: true,
    ultraview_id: false,
    ultraview_password: false,
    anydesk_id: true,
    anydesk_password: true,
    note: false,
    status: true,
    is_deleted: false,
    created_at: false,
    updated_at: false
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      search_exact: false,
      showEditModal: false,
      showViewModal: false,
      showAddModal: false,
      showDeleteModal: false,
      selectedPCInfo: null,
      isEditMode: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      editFormData: {
        SN: '',
        location_id: '',
        operating_system: '',
        version: '',
        iso_file_name: '',
        c_drive_capacity: '',
        install_date: '',
        price: '',
        ref_device_pack_location_id: '',
        use_type: 'ETSY_SHOP',
        ultraview_id: '',
        ultraview_password: '',
        anydesk_id: '',
        anydesk_password: '',
        note: '',
        status: 'ACTIVE'
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 PC Info';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Parse boolean values
      if (queryObject.search_exact !== undefined) {
        queryObject.search_exact = queryObject.search_exact === 'true';
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1PCInfo_ViewConfig'));
      
      // Use search_exact from URL if present, otherwise from localStorage
      const searchExact = queryObject.search_exact !== undefined 
        ? queryObject.search_exact 
        : JSON.parse(localStorage.getItem('TKT1PCInfo_search_exact')) || false;
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        search_exact: searchExact
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1PCInfos(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_pc_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1PCInfo_ViewConfig'));
      var searchExact = JSON.parse(localStorage.getItem('TKT1PCInfo_search_exact')) || false;
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1PCInfos(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1PCInfos(apiQuery);
        })
      }
    }
  }

  componentWillReceiveProps(props) {
    // No need to update state since we're using props directly
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_pc_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      status: this.state.query.status,
      use_type: this.state.query.use_type
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1PCInfos(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_pc_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      status: this.state.query.status,
      use_type: this.state.query.use_type
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1PCInfos(apiQuery);
  }

  handleSearchExactChange = (e) => {
    const searchExact = e.target.checked;
    this.setState({ search_exact: searchExact });
    localStorage.setItem('TKT1PCInfo_search_exact', JSON.stringify(searchExact));
  }


  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_pc_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      operating_system: this.state.query.operating_system,
      status: newQuery.status,
      use_type: this.state.query.use_type
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1PCInfos(apiQuery);
  }

  handleUseTypeChange = (e) => {
    const newQuery = { ...this.state.query, use_type: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_pc_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      operating_system: this.state.query.operating_system,
      status: this.state.query.status,
      use_type: newQuery.use_type
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1PCInfos(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config separately - not related to query
      localStorage.setItem('TKT1PCInfo_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'CANCEL':
        return 'Hủy';
      default:
        return status;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
      this.showToast('Đã copy vào clipboard!', 'success');
    }).catch(err => {
      console.error('Failed to copy: ', err);
      this.showToast('Lỗi khi copy!', 'error');
    });
  }

  // Show toast notification
  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });
    
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  // Modal handlers
  handleViewClick = (pcInfo) => {
    this.setState({
      showViewModal: true,
      selectedPCInfo: pcInfo,
      isEditMode: false
    });
  }

  handleEditClick = (pcInfo) => {
    this.setState({
      showEditModal: true,
      selectedPCInfo: pcInfo,
      isEditMode: true,
      editFormData: {
        SN: pcInfo.SN || '',
        location_id: pcInfo.location_id || '',
        operating_system: pcInfo.operating_system || '',
        version: pcInfo.version || '',
        iso_file_name: pcInfo.iso_file_name || '',
        c_drive_capacity: pcInfo.c_drive_capacity || '',
        install_date: pcInfo.install_date ? new Date(pcInfo.install_date).toISOString().split('T')[0] : '',
        price: pcInfo.price || '',
        ref_device_pack_location_id: pcInfo.ref_device_pack_location_id || '',
        use_type: pcInfo.use_type || 'ETSY_SHOP',
        ultraview_id: pcInfo.ultraview_id || '',
        ultraview_password: pcInfo.ultraview_password || '',
        anydesk_id: pcInfo.anydesk_id || '',
        anydesk_password: pcInfo.anydesk_password || '',
        note: pcInfo.note || '',
        status: pcInfo.status || 'ACTIVE'
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedPCInfo: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedPCInfo: null,
      isEditMode: false,
      editFormData: {
        SN: '',
        location_id: '',
        operating_system: '',
        version: '',
        iso_file_name: '',
        c_drive_capacity: '',
        install_date: '',
        price: '',
        ref_device_pack_location_id: '',
        use_type: 'ETSY_SHOP',
        ultraview_id: '',
        ultraview_password: '',
        anydesk_id: '',
        anydesk_password: '',
        note: '',
        status: 'ACTIVE'
      }
    });
  }

  handleAddClick = () => {
    this.setState({
      showAddModal: true,
      editFormData: {
        SN: '',
        location_id: '',
        operating_system: '',
        version: '',
        iso_file_name: '',
        c_drive_capacity: '',
        install_date: '',
        price: '',
        ref_device_pack_location_id: '',
        use_type: 'ETSY_SHOP',
        ultraview_id: '',
        ultraview_password: '',
        anydesk_id: '',
        anydesk_password: '',
        note: '',
        status: 'ACTIVE'
      }
    });
  }

  handleCloseAddModal = () => {
    this.setState({
      showAddModal: false,
      editFormData: {
        SN: '',
        location_id: '',
        operating_system: '',
        version: '',
        iso_file_name: '',
        c_drive_capacity: '',
        install_date: '',
        price: '',
        ref_device_pack_location_id: '',
        use_type: 'ETSY_SHOP',
        ultraview_id: '',
        ultraview_password: '',
        anydesk_id: '',
        anydesk_password: '',
        note: '',
        status: 'ACTIVE'
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleSaveEdit = async () => {
    const { selectedPCInfo, editFormData } = this.state;
    
    if (!selectedPCInfo || !selectedPCInfo._id) {
      this.showToast('Không tìm thấy thông tin PC để cập nhật', 'error');
      return;
    }

    try {
      // Prepare data for update
      const updateData = {
        ...editFormData,
        price: editFormData.price ? parseFloat(editFormData.price) : 0,
        install_date: editFormData.install_date ? new Date(editFormData.install_date).toISOString() : null
      };

      // Call update action
      await this.props.updateTKT1PCInfo(selectedPCInfo._id, updateData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1PCInfos(apiQuery);
      
      this.showToast('Cập nhật thông tin PC thành công!', 'success');
    } catch (error) {
      console.error('Error updating PC info:', error);
      this.showToast('Lỗi khi cập nhật thông tin PC. Vui lòng thử lại.', 'error');
    }
  }

  handleSaveAdd = async () => {
    const { editFormData } = this.state;
    
    // Validate required fields
    if (!editFormData.SN || !editFormData.SN.trim()) {
      this.showToast('Vui lòng nhập Serial Number', 'error');
      return;
    }

    try {
      // Prepare data for create
      const createData = {
        ...editFormData,
        price: editFormData.price ? parseFloat(editFormData.price) : 0,
        install_date: editFormData.install_date ? new Date(editFormData.install_date).toISOString() : null
      };

      // Call create action
      await this.props.createTKT1PCInfo(createData);
      
      // Close modal
      this.handleCloseAddModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1PCInfos(apiQuery);
      
      this.showToast('Thêm PC mới thành công!', 'success');
    } catch (error) {
      console.error('Error creating PC info:', error);
      this.showToast('Lỗi khi thêm PC mới. Vui lòng thử lại.', 'error');
    }
  }

  // Delete handlers
  handleDeleteClick = (pcInfo) => {
    this.setState({
      showDeleteModal: true,
      selectedPCInfo: pcInfo
    });
  }

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedPCInfo: null
    });
  }

  handleConfirmDelete = async () => {
    const { selectedPCInfo } = this.state;
    
    if (!selectedPCInfo || !selectedPCInfo._id) {
      this.showToast('Không tìm thấy thông tin PC để xóa', 'error');
      return;
    }

    try {
      // Call delete action
      await this.props.deleteTKT1PCInfo(selectedPCInfo._id);
      
      // Close modal
      this.handleCloseDeleteModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1PCInfos(apiQuery);
      
      this.showToast('Xóa PC thành công!', 'success');
    } catch (error) {
      console.error('Error deleting PC info:', error);
      this.showToast('Lỗi khi xóa PC. Vui lòng thử lại.', 'error');
    }
  }

  // Helper function to prepare API query (remove showColumns and only include search_exact if explicitly enabled)
  prepareApiQuery = (query) => {
    const { showColumns, search, status, use_type, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Add use type filter if selected
    if (use_type && use_type.trim()) {
      apiQuery.use_type = use_type;
    }
    
    // Only add search_exact if user explicitly enabled it
    if (search && search.trim() && this.state.search_exact === true) {
      apiQuery.search_exact = true;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      operating_system: this.state.query.operating_system,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1PCInfos(apiQuery);
      localStorage.setItem('tkt1_pc_query', JSON.stringify(trimmedQuery));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-device/pc-info',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    // Trim search value before sending to API
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      operating_system: this.state.query.operating_system,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1PCInfos(apiQuery);
    localStorage.setItem('tkt1_pc_query', JSON.stringify(trimmedQuery));
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      operating_system: this.state.query.operating_system,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ pcInfos: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1PCInfos(apiQuery);
        localStorage.setItem('tkt1_pc_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo SN, location, OS..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="ACTIVE">Hoạt động</option>
              <option value="INACTIVE">Không hoạt động</option>
              <option value="CANCEL">Hủy</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Loại sử dụng</InputGroup.Text>
            <Form.Select
              value={this.state.query.use_type}
              onChange={this.handleUseTypeChange}
            >
              <option value="">Tất cả</option>
              <option value="ETSY_SHOP">ETSY_SHOP</option>
              <option value="VM_MARKETING">VM_MARKETING</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="location_id">Location ID</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="SN">Serial Number</option>
              <option value="install_date">Ngày cài đặt</option>
              <option value="price">Giá</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderPCInfoTable = () => {
    const { pcInfos } = this.props;
    const { showColumns } = this.state;
    
    // Ensure pcInfos is an array and filter out any null/undefined items
    const safePCInfos = Array.isArray(pcInfos) ? pcInfos.filter(info => info != null && typeof info === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safePCInfos || safePCInfos.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.location_id && <th>Location ID</th>}
              {showColumns.SN && <th>Serial Number</th>}
              {showColumns.operating_system && <th>Hệ điều hành</th>}
              {showColumns.version && <th>Phiên bản</th>}
              {showColumns.iso_file_name && <th>ISO File</th>}
              {showColumns.c_drive_capacity && <th>Dung lượng C:</th>}
              {showColumns.install_date && <th>Ngày cài đặt</th>}
              {showColumns.price && <th>Giá</th>}
              {showColumns.ref_device_pack_location_id && <th>Device Pack Location ID</th>}
              {showColumns.use_type && <th>Loại sử dụng</th>}
              {showColumns.ultraview_id && <th>Ultraview ID</th>}
              {showColumns.ultraview_password && <th>Ultraview Password</th>}
              {showColumns.anydesk_id && <th>AnyDesk ID</th>}
              {showColumns.anydesk_password && <th>AnyDesk Password</th>}
              {showColumns.note && <th>Ghi chú</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.is_deleted && <th>Đã xóa</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.updated_at && <th>Ngày cập nhật</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.location_id && <th>Location ID</th>}
            {showColumns.SN && <th>Serial Number</th>}
            {showColumns.operating_system && <th>Hệ điều hành</th>}
            {showColumns.version && <th>Phiên bản</th>}
            {showColumns.iso_file_name && <th>ISO File</th>}
            {showColumns.c_drive_capacity && <th>Dung lượng C:</th>}
            {showColumns.install_date && <th>Ngày cài đặt</th>}
            {showColumns.price && <th>Giá</th>}
            {showColumns.ref_device_pack_location_id && <th>Device Pack ID</th>}
            {showColumns.use_type && <th>Loại sử dụng</th>}
            {showColumns.ultraview_id && <th>Ultraview ID</th>}
            {showColumns.ultraview_password && <th>Ultraview Password</th>}
            {showColumns.anydesk_id && <th>AnyDesk ID</th>}
            {showColumns.anydesk_password && <th>AnyDesk Password</th>}
            {showColumns.note && <th>Ghi chú</th>}
            {showColumns.status && <th>Trạng thái</th>}
            {showColumns.is_deleted && <th>Đã xóa</th>}
            {showColumns.created_at && <th>Ngày tạo</th>}
            {showColumns.updated_at && <th>Ngày cập nhật</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safePCInfos.map((info, index) => {
            if (!info || typeof info !== 'object') return null;
              
              return (
                <tr key={info._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.location_id && (
                    <td>{info.location_id || '-'}</td>
                  )}
                  {showColumns.SN && (
                    <td>
                      {info.SN ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{info.SN}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.SN)}
                            title="Copy Serial Number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.operating_system && (
                    <td>{info.operating_system || '-'}</td>
                  )}
                  {showColumns.version && (
                    <td>{info.version || '-'}</td>
                  )}
                  {showColumns.iso_file_name && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.iso_file_name}>
                        {info.iso_file_name || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.c_drive_capacity && (
                    <td>{info.c_drive_capacity || '-'}</td>
                  )}
                  {showColumns.install_date && (
                    <td>
                      {info.install_date ? new Date(info.install_date).toLocaleDateString('vi-VN') : '-'}
                    </td>
                  )}
                  {showColumns.price && (
                    <td>
                      {info.price ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(info.price) : '-'}
                    </td>
                  )}
                  {showColumns.ref_device_pack_location_id && (
                    <td>
                      {info.ref_device_pack_location_id ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.9em',
                            padding: '6px 10px'
                          }}
                        >
                          {info.ref_device_pack_location_id}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.use_type && (
                    <td>
                      {info.use_type ? (
                        <Badge 
                          bg={info.use_type === 'ETSY_SHOP' ? 'primary' : 'secondary'}
                          style={{ 
                            fontSize: '0.8em',
                            padding: '4px 8px'
                          }}
                        >
                          {info.use_type}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ultraview_id && (
                    <td>
                      {info.ultraview_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>{info.ultraview_id}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.ultraview_id)}
                            title="Copy Ultraview ID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ultraview_password && (
                    <td>
                      {info.ultraview_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ whiteSpace: 'nowrap' }} 
                               title={info.ultraview_password}>
                            {info.ultraview_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.ultraview_password)}
                            title="Copy Ultraview Password"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.anydesk_id && (
                    <td>
                      {info.anydesk_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>{info.anydesk_id}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.anydesk_password && (
                    <td>
                      {info.anydesk_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ whiteSpace: 'nowrap' }} 
                               title={info.anydesk_password}>
                            {info.anydesk_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(info.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={info.note}>
                        {info.note || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {info.status ? (
                        <Badge 
                          bg={
                            info.status === 'ACTIVE' ? 'success' :
                            info.status === 'INACTIVE' ? 'warning' :
                            info.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(info.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.is_deleted && (
                    <td>
                      <Badge bg={info.is_deleted ? "danger" : "success"}>
                        {info.is_deleted ? "Đã xóa" : "Hoạt động"}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>
                      {info.created_at ? new Date(info.created_at).toLocaleDateString('vi-VN') : '-'}
                    </td>
                  )}
                  {showColumns.updated_at && (
                    <td>
                      {info.updated_at ? new Date(info.updated_at).toLocaleDateString('vi-VN') : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(info)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(info)}
                      />
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa PC"
                        onClick={() => this.handleDeleteClick(info)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 PC Info
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <Button
                variant="success"
                size="sm"
                onClick={this.handleAddClick}
                title="Thêm PC mới"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderPCInfoTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    SN: 'Serial Number',
                    location_id: 'Location ID',
                    operating_system: 'Hệ điều hành',
                    version: 'Phiên bản',
                    iso_file_name: 'ISO File',
                    c_drive_capacity: 'Dung lượng C:',
                    install_date: 'Ngày cài đặt',
                    price: 'Giá',
                    ref_device_pack_location_id: 'Device Pack Location ID',
                    use_type: 'Loại sử dụng',
                    ultraview_id: 'Ultraview ID',
                    ultraview_password: 'Ultraview Password',
                    anydesk_id: 'AnyDesk ID',
                    anydesk_password: 'AnyDesk Password',
                    note: 'Ghi chú',
                    status: 'Trạng thái',
                    is_deleted: 'Đã xóa',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin PC</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedPCInfo && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Serial Number:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedPCInfo.SN}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Location ID:</strong> 
                    <div className="mt-1">{this.state.selectedPCInfo.location_id || '-'}</div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Hệ điều hành:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                        {this.state.selectedPCInfo.operating_system || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Phiên bản:</strong> 
                    <div className="mt-1">{this.state.selectedPCInfo.version || '-'}</div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>ISO File:</strong> 
                    <div className="mt-1" style={{ wordBreak: 'break-all' }}>
                      {this.state.selectedPCInfo.iso_file_name || '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Dung lượng C:</strong> 
                    <div className="mt-1">{this.state.selectedPCInfo.c_drive_capacity || '-'}</div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày cài đặt:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.install_date ? 
                        new Date(this.state.selectedPCInfo.install_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.created_at ? 
                        new Date(this.state.selectedPCInfo.created_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Giá:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.price ? 
                        <span className="text-success fw-bold">
                          {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(this.state.selectedPCInfo.price)}
                        </span> : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Device Pack Location ID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.ref_device_pack_location_id ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.9em',
                            padding: '6px 10px'
                          }}
                        >
                          {this.state.selectedPCInfo.ref_device_pack_location_id}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Loại sử dụng:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.use_type ? (
                        <Badge 
                          bg={this.state.selectedPCInfo.use_type === 'ETSY_SHOP' ? 'primary' : 'secondary'}
                          style={{ 
                            fontSize: '0.8em',
                            padding: '4px 8px'
                          }}
                        >
                          {this.state.selectedPCInfo.use_type}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    {/* Empty column for balance */}
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ultraview ID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.ultraview_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                            {this.state.selectedPCInfo.ultraview_id}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.ultraview_id)}
                            title="Copy Ultraview ID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ultraview Password:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.ultraview_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ wordBreak: 'break-all' }}>
                            {this.state.selectedPCInfo.ultraview_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.ultraview_password)}
                            title="Copy Ultraview Password"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>AnyDesk ID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.anydesk_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                            {this.state.selectedPCInfo.anydesk_id}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>AnyDesk Password:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.anydesk_password ? (
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ wordBreak: 'break-all' }}>
                            {this.state.selectedPCInfo.anydesk_password}
                          </div>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedPCInfo.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.status ? (
                        <Badge 
                          bg={
                            this.state.selectedPCInfo.status === 'ACTIVE' ? 'success' :
                            this.state.selectedPCInfo.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedPCInfo.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedPCInfo.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Đã xóa:</strong> 
                    <div className="mt-1">
                      <Badge bg={this.state.selectedPCInfo.is_deleted ? "danger" : "success"}>
                        {this.state.selectedPCInfo.is_deleted ? "Đã xóa" : "Hoạt động"}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedPCInfo.note || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Metadata Information */}
                {this.state.selectedPCInfo.metadata && (
                  <Row className="mb-4">
                    <Col>
                      <h5 className="text-primary">Thông tin phần cứng</h5>
                      <hr />
                    </Col>
                  </Row>
                )}
                {this.state.selectedPCInfo.metadata && (
                  <Row className="mb-3">
                    <Col md="6">
                      <strong>Thương hiệu:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.brand || '-'}</div>
                    </Col>
                    <Col md="6">
                      <strong>Model:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.model || '-'}</div>
                    </Col>
                  </Row>
                )}
                {this.state.selectedPCInfo.metadata && (
                  <Row className="mb-3">
                    <Col md="6">
                      <strong>Loại máy:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.machine_type || '-'}</div>
                    </Col>
                    <Col md="6">
                      <strong>Số model:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.model_number || '-'}</div>
                    </Col>
                  </Row>
                )}
                {this.state.selectedPCInfo.metadata && (
                  <Row className="mb-3">
                    <Col md="6">
                      <strong>Ngày sản xuất:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.mfg_date || '-'}</div>
                    </Col>
                    <Col md="6">
                      <strong>Nơi sản xuất:</strong> 
                      <div className="mt-1">{this.state.selectedPCInfo.metadata.made_in || '-'}</div>
                    </Col>
                  </Row>
                )}
                
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedPCInfo.updated_at ? 
                        new Date(this.state.selectedPCInfo.updated_at).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    {/* Empty column for balance */}
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa PC</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Serial Number <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.SN}
                      onChange={(e) => this.handleEditInputChange('SN', e.target.value)}
                      placeholder="Nhập Serial Number"
                      disabled
                    />
                    <Form.Text className="text-muted">
                      Serial Number không thể thay đổi
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location_id}
                      onChange={(e) => this.handleEditInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Hệ điều hành</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.operating_system}
                      onChange={(e) => this.handleEditInputChange('operating_system', e.target.value)}
                    >
                      <option value="">-- Chọn hệ điều hành --</option>
                      <option value="WINDOWS 7">Windows 7</option>
                      <option value="WINDOWS 10">Windows 10</option>
                      <option value="WINDOWS 11">Windows 11</option>
                      <option value="LINUX">Linux</option>
                      <option value="MACOS">macOS</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phiên bản</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.version}
                      onChange={(e) => this.handleEditInputChange('version', e.target.value)}
                      placeholder="Nhập phiên bản"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>ISO File</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.iso_file_name}
                      onChange={(e) => this.handleEditInputChange('iso_file_name', e.target.value)}
                      placeholder="Nhập tên file ISO"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Dung lượng C:</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c_drive_capacity}
                      onChange={(e) => this.handleEditInputChange('c_drive_capacity', e.target.value)}
                      placeholder="Nhập dung lượng ổ C"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày cài đặt</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.install_date}
                      onChange={(e) => this.handleEditInputChange('install_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giá (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.price}
                      onChange={(e) => this.handleEditInputChange('price', e.target.value)}
                      placeholder="Nhập giá"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_device_pack_location_id}
                      onChange={(e) => this.handleEditInputChange('ref_device_pack_location_id', e.target.value)}
                      placeholder="Nhập Device Pack Location ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại sử dụng</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.use_type}
                      onChange={(e) => this.handleEditInputChange('use_type', e.target.value)}
                    >
                      <option value="ETSY_SHOP">ETSY_SHOP</option>
                      <option value="VM_MARKETING">VM_MARKETING</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  {/* Empty column for balance */}
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ultraview ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ultraview_id}
                      onChange={(e) => this.handleEditInputChange('ultraview_id', e.target.value)}
                      placeholder="Nhập Ultraview ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ultraview Password</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ultraview_password}
                      onChange={(e) => this.handleEditInputChange('ultraview_password', e.target.value)}
                      placeholder="Nhập Ultraview Password"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>AnyDesk ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.anydesk_id}
                      onChange={(e) => this.handleEditInputChange('anydesk_id', e.target.value)}
                      placeholder="Nhập AnyDesk ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>AnyDesk Password</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.anydesk_password}
                      onChange={(e) => this.handleEditInputChange('anydesk_password', e.target.value)}
                      placeholder="Nhập AnyDesk Password"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Modal */}
        <Modal show={this.state.showAddModal} onHide={this.handleCloseAddModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm PC mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Serial Number <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.SN}
                      onChange={(e) => this.handleEditInputChange('SN', e.target.value)}
                      placeholder="Nhập Serial Number"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location_id}
                      onChange={(e) => this.handleEditInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Hệ điều hành</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.operating_system}
                      onChange={(e) => this.handleEditInputChange('operating_system', e.target.value)}
                    >
                      <option value="">-- Chọn hệ điều hành --</option>
                      <option value="WINDOWS 7">Windows 7</option>
                      <option value="WINDOWS 10">Windows 10</option>
                      <option value="WINDOWS 11">Windows 11</option>
                      <option value="LINUX">Linux</option>
                      <option value="MACOS">macOS</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phiên bản</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.version}
                      onChange={(e) => this.handleEditInputChange('version', e.target.value)}
                      placeholder="Nhập phiên bản"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>ISO File</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.iso_file_name}
                      onChange={(e) => this.handleEditInputChange('iso_file_name', e.target.value)}
                      placeholder="Nhập tên file ISO"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Dung lượng C:</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.c_drive_capacity}
                      onChange={(e) => this.handleEditInputChange('c_drive_capacity', e.target.value)}
                      placeholder="Nhập dung lượng ổ C"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày cài đặt</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.install_date}
                      onChange={(e) => this.handleEditInputChange('install_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giá (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.price}
                      onChange={(e) => this.handleEditInputChange('price', e.target.value)}
                      placeholder="Nhập giá"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_device_pack_location_id}
                      onChange={(e) => this.handleEditInputChange('ref_device_pack_location_id', e.target.value)}
                      placeholder="Nhập Device Pack Location ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại sử dụng</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.use_type}
                      onChange={(e) => this.handleEditInputChange('use_type', e.target.value)}
                    >
                      <option value="ETSY_SHOP">ETSY_SHOP</option>
                      <option value="VM_MARKETING">VM_MARKETING</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  {/* Empty column for balance */}
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ultraview ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ultraview_id}
                      onChange={(e) => this.handleEditInputChange('ultraview_id', e.target.value)}
                      placeholder="Nhập Ultraview ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ultraview Password</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ultraview_password}
                      onChange={(e) => this.handleEditInputChange('ultraview_password', e.target.value)}
                      placeholder="Nhập Ultraview Password"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>AnyDesk ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.anydesk_id}
                      onChange={(e) => this.handleEditInputChange('anydesk_id', e.target.value)}
                      placeholder="Nhập AnyDesk ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>AnyDesk Password</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.anydesk_password}
                      onChange={(e) => this.handleEditInputChange('anydesk_password', e.target.value)}
                      placeholder="Nhập AnyDesk Password"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAddModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleSaveAdd}>
              Thêm mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Xác nhận xóa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedPCInfo && (
              <div>
                <p>Bạn có chắc chắn muốn xóa PC này không?</p>
                <div className="alert alert-warning">
                  <strong>Serial Number:</strong> {this.state.selectedPCInfo.SN}<br/>
                  <strong>Location ID:</strong> {this.state.selectedPCInfo.location_id || '-'}
                </div>
                <p className="text-danger"><strong>Lưu ý:</strong> Hành động này không thể hoàn tác!</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
              Hủy
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              Xóa
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Toast Notification */}
        <ToastContainer 
          position="top-end" 
          className="p-3"
          style={{ 
            position: 'fixed', 
            top: '20px', 
            right: '20px', 
            zIndex: 9999 
          }}
        >
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType === 'success' ? 'success' : 'danger'}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">
                {this.state.toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body>
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pcInfos: state.tkt1PCInfoReducer.pcInfos,
    totalCount: state.tkt1PCInfoReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1PCInfos, updateTKT1PCInfo, createTKT1PCInfo, deleteTKT1PCInfo })(TKT1PCInfo);
